<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{
        rowIndex + 1
      }}</span>
    </td>
    <!-- ประเภทสินค้า-->
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'productCode' + _uid"
        :name="'productCode' + _uid"
        :select2-options="productCodeOptions"
        :disabled="item.isDisableProduct"
        v-model="item.productCode"
        ref="productCode"
        data-msg-required="กรุณาเลือกสินค้า"
      ></select2>
      <span class="form-text"></span>
    </td>
    <!-- ประเภทสินค้า-->

    <!-- ต้นทุนสินค้า(บาท)	-->
    <td class="form-group">
      <currency-input
        class="form-control required text-right"
        :id="'productCost' + _uid"
        :name="'productCost' + _uid"
        v-model="item.productCost"
        v-currency="{ locale, currency }"
        auto-decimal-mode:true
        placeholder="ราคา"
        data-msg-required="กรุณากรอกจำนวน"
        v-on:keyup="changeProductCost($event, _uid)"
      />
      <span class="form-text"></span>
    </td>
    <!-- ต้นทุนสินค้า(บาท)	-->

    <td v-for="index in 12" :key="index" class="form-group">
      <input
        v-if="item.isDisableMonth[index]"
        readonly
        class="form-control text-right"
        :id="'isMonth' + index + _uid"
        :name="'isMonth' + index + _uid"
        :value="item.isMonth[index]"
        v-currency="{
          locale: 'th',
          currency: null,
          precision: 0,
        }"
        v-on:keyup="changeMonth($event, index, _uid)"
      />
      <input
        v-if="!item.isDisableMonth[index]"
        class="form-control text-right"
        :id="'isMonth' + index + _uid"
        :name="'isMonth' + index + _uid"
        :value="item.isMonth[index]"
        v-currency="{
          locale: 'th',
          currency: null,
          precision: 0,
        }"
        v-on:keyup="changeMonth($event, index, _uid)"
        :readonly="(yearSelected == currentYear && index > currentMonth)"
      />
      <span class="form-text"></span>
    </td>

    <!-- จำนวนรวม(บาท)			-->
    <td class="form-group">
      <currency-input
        readonly
        class="form-control  text-right"
        :id="'totalCost' + _uid"
        :name="'totalCost' + _uid"
        :value="ChecktotalCostAll(_uid)"
        v-currency="{ locale, currency }"
        auto-decimal-mode:true
      />
    </td>
    <!-- จำนวนรวม(บาท)			-->

    <!-- จำนวนเฉลี่ย(บาท/เดือน)				-->
    <td class="form-group">
      <currency-input
        readonly
        class="form-control  text-right"
        :id="'totalCalOfmonth' + _uid"
        :name="'totalCalOfmonth' + _uid"
        :value="totalCalOfmonthAll"
        v-currency="{ locale, currency }"
        auto-decimal-mode:true
      />
      <span class="form-text"></span>
    </td>
    <!-- จำนวนเฉลี่ย(บาท/เดือน)			-->

    <!-- จัดการ -->
    <td class="form-group">
      <center>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveItemClick"
          v-if="!item.isDisableProduct"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td>
  </tr>
</template>

<script>
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  props: {
    rowIndex: Number,
    item: {
      type: Object,
      required: true,
    },
    kPIProductType: {
      type: String,
      required: true
    },
    yearSelected: {
      type: [ String, Number ]
    }
  },
  data() {
    var self = this;
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      isMonth: [],
      currency: "THB",
      locale: "th",
      totalCostAll: 0,
      totalCalOfmonthAll: 0,
      productCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productTypeOption: self.kPIProductType
            };
            return query;
          },
          processResults: function(data, params) {
            if (self.item.listProductCode != null) {
              data.results = data.results.filter(
                (o) => !self.item.listProductCode.includes(o.id)
              );
            }
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {
    totalCost() {
      var qtyTotal = 0;
      this.item.isMonth.forEach((element) => {
        qtyTotal = qtyTotal + Number(element);
      });
      return (this.item.totalCost = this.item.productCost * qtyTotal);
    },
    totalCalOfmonth() {
      var length = 0;
      this.item.isMonth.forEach((element) => {
        if (element != 0) {
          length++;
        }
      });
      return (this.item.totalCalOfmonth = Math.ceil(
        this.item.totalCost / length
      ));
    },
  },
  methods: {
    ChecktotalCostAll(uid) {
      this.totalCost2();
      this.totalCalOfmonth2();
      $("#totalCost" + uid).val(this.totalCostAll);
      $("#totalCost" + uid).keyup();
      $("#totalCalOfmonth" + uid).keyup();
      return this.totalCostAll;
    },
    onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item)
    },
    changeProductCost(e, uid) {
      this.totalCost2();
      this.totalCalOfmonth2();
    },
    changeMonth(e, i, uid) {
      this.isMonth[i] = e.target.value;
      this.totalCost2();
      this.totalCalOfmonth2();
      $("#totalCost" + uid).val(this.totalCostAll);
      $("#totalCost" + uid).keyup();
      $("#totalCalOfmonth" + uid).keyup();
      for (var j = 1; j < this.item.isMonth.length; j++) {
        $("#isMonth" + j + uid).keyup();
      }
      $("#isMonth" + i + uid).keyup();
    },
    totalCost2() {
      var qtyTotal = 0;
      this.item.isMonth.forEach((element) => {
        qtyTotal = qtyTotal + Number(element);
      });
      this.totalCostAll = this.item.totalCost =
        this.item.productCost * qtyTotal;
    },
    totalCalOfmonth2() {
      var length = 0;
      this.item.isMonth.forEach((element) => {
        if (element != 0) {
          length++;
        }
      });
      if (length == 0) this.totalCalOfmonthAll = this.item.totalCalOfmonth = 0;
      else
        this.totalCalOfmonthAll = this.item.totalCalOfmonth = Math.ceil(
          this.totalCostAll / length
        );
    },
  },
  mounted() {
    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required"),
        },
      });
    });
    this.isMonth = this.item.isMonth;
    this.totalCost2();
    this.totalCalOfmonth2();
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/KPI/Products/ProductItemRow.vue